import { render, staticRenderFns } from "./constructionControlNode.vue?vue&type=template&id=58e87623&scoped=true&"
import script from "./constructionControlNode.vue?vue&type=script&lang=js&"
export * from "./constructionControlNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e87623",
  null
  
)

export default component.exports